import { watchInspectRecordRecord,updateInspectRecord,saveInspectRecord} from '@/api/crmedical/device/deviceInspectionStandard'
let bussinessLogic = {
    //临时巡检记录查看
  checkTemporaryDetail(id) {
    return new Promise(function(resolve, reject){   
      watchInspectRecordRecord({id:id}).then(({data})=>{
        resolve(data);
      }).catch(res=>{
          //失败的回调
          reject(res);  
      })}
    )
   
  },
  //临时巡检记录新增
  addTemporaryRecord(val) {
    return new Promise(function(resolve, reject){   
      saveInspectRecord(val).then(({data})=>{
        resolve(data);
      }).catch(res=>{
          //失败的回调
          reject(res);  
      })}
    )
   
  },
  //临时巡检记录修改
  updateTemporaryRecord(val) {
    return new Promise(function(resolve, reject){   
      updateInspectRecord(val).then(({data})=>{
        resolve(data);
      }).catch(res=>{
          //失败的回调
          reject(res);  
      })}
    )
   
  },
  //工单巡检记录查看
  checkWorkOrderDetail(val,success,fail) {
    
  },
  //工单巡检记录新增
  addWorkOrderRecord(val) {

  },
  //工单巡检记录修改
  updatWorkOrderRecord(val) {

  },
};
export default bussinessLogic;
